import { BottomSheetModal } from '@gorhom/bottom-sheet';
import type { RefObject } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import BottomSheet from 'shared/components/vxl/BottomSheet/BottomSheet';
import Button from 'shared/components/vxl/Button/Button';
import BodyBaseText from 'shared/components/vxl/typography/primary/body/BodyBaseText';
import TitleMdText from 'shared/components/vxl/typography/primary/title/TitleMdText';
import theme from 'shared/styles/theme';

interface WhatCouldChangeBottomSheetProps {
  ref: RefObject<BottomSheetModal | null>;
}

const WhatCouldChangeBottomSheet = ({
  ref,
}: WhatCouldChangeBottomSheetProps) => {
  const { t: translatedText } = useTranslation('payLater', {
    keyPrefix: 'whatCouldChange',
  });

  const handleDonePress = () => {
    ref.current?.dismiss();
  };

  // TODO JT-163173: Figma names the maximum plan increase (15%) and the fee
  // (6%). Add them once the contract returns these values or this copy.
  return (
    <BottomSheet ref={ref}>
      <View style={styles.content}>
        <TitleMdText accessibilityRole="header" numberOfLines={0}>
          {translatedText('title')}
        </TitleMdText>
        <BodyBaseText numberOfLines={0}>
          {translatedText('finalAmount')}
        </BodyBaseText>
        <BodyBaseText numberOfLines={0}>
          {translatedText('planUpdates')}
        </BodyBaseText>
      </View>
      <View style={styles.buttonContainer}>
        <Button label={translatedText('done')} onPress={handleDonePress} />
      </View>
    </BottomSheet>
  );
};

const styles = StyleSheet.create({
  buttonContainer: {
    padding: theme.spacing.m,
  },
  content: {
    gap: theme.spacing.m,
    padding: theme.spacing.m,
  },
});

export default WhatCouldChangeBottomSheet;
